import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { googleAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }

    const sessionId = match[1];
    (async () => {
      try {
        await googleAuth(sessionId);
        toast.success("Welcome to PhD Reader!");
        // Clean the URL hash before navigating
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [googleAuth, navigate]);

  return (
    <div className="min-h-screen bg-neo-bg flex items-center justify-center" data-testid="auth-callback">
      <div className="neo-card text-center p-8">
        <div className="w-12 h-12 border-4 border-neo-yellow border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="font-heading font-bold text-lg">Signing you in...</p>
      </div>
    </div>
  );
}
